import React from "react";

import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { HamburgerMenu, RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";

import { UserMenu } from "./UserMenu";
import { OrderSearchBar } from "./components/OrderSearchBar";
import { MarketplaceClock } from "./components/MarketplaceClock";
import { getRuntimeEnv } from "../../providers/getRuntimeEnv";
import { WorkspaceDrawer } from "../workspace/WorkspaceDrawer";

type HeaderProps = RefineThemedLayoutV2HeaderProps & {
  showTitle?: boolean;
  showMarketplace?: boolean;
};

export const HeaderWithTitle: React.FC<HeaderProps> = (props: HeaderProps) => {
  return <Header {...props} showTitle showMarketplace={false} />;
};

export const HeaderWithTitleAndMarketplace: React.FC<HeaderProps> = (
  props: HeaderProps,
) => {
  return <Header {...props} showTitle />;
};

export const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { showTitle = false, sticky = false, showMarketplace = true } = props;
  const runtimeEnv = getRuntimeEnv();
  const isDevEnv = runtimeEnv === "dev";
  const title = isDevEnv ? "SyncroDev" : "Syncrosale";
  const logo = isDevEnv ? "/icons/logo-dev.svg" : "/icons/logo.svg";

  return (
    <>
      <WorkspaceDrawer />
      <AppBar position={sticky ? "sticky" : "relative"}>
        <Toolbar>
          {showTitle ? (
            <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              <img
                src={logo}
                alt="App Icon"
                style={{ width: 48, height: 48, objectFit: "contain" }}
              />
              <Typography
                variant="h6"
                component="div"
                fontWeight={700}
                sx={{ marginLeft: 1 }}
              >
                {title}
              </Typography>
            </Box>
          ) : (
            <HamburgerMenu />
          )}

          {/* SEARCH BAR */}
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              mx: { xs: 1, md: 3 },
            }}
          >
            <OrderSearchBar />
          </Box>

          {/* RIGHT CONTROLS */}
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            gap={3}
            sx={{ flexShrink: 0 }}
          >
            <MarketplaceClock />
            <UserMenu showMarketplace={showMarketplace} />
          </Stack>
        </Toolbar>
      </AppBar>
    </>
  );
};
